export function decodeJWT(token: string): any {
  try {
    const payload = token.split('.')[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const json = JSON.parse(decodeURIComponent(escape(decoded)));

    // Check if token is expired
    if (json.exp && Date.now() >= json.exp * 1000) {
      return null;
    }

    return json;
  } catch {
    return null;
  }
}
